<ng-container *ngIf="!eventService.loadEventTournaments;else loading">


  <mat-tab-group class="christmas-tabs">

    <div class="snow"></div>


    <mat-tab label="tab2">
      <ng-template mat-tab-label>
        <i class="icon icon-shield"></i>
        Tournaments
      </ng-template>

      <div style="margin:10px 0;" *ngFor="let tournament of (eventService.eventTournaments|async)?.data">
        <div class="col-sm-4">
          <a class="tag-container" href="https://www.gbarena.com/tournaments/{{tournament.code}}" target="_blank">
            <div class="tag">

              <div class="tag-side tag-3-side">
                <div class="tag-text tag-3-text">
                  <div class="snow"></div>
                  <div class="tag-cover" [ngStyle]="{'background-image': 'url('+tournament.cover_picture+')'}">
                  </div>

                  <div class="text">
                    <h1>{{tournament.name}}</h1>
                    <p style="margin: 10px 0;">
                      <i class="icon-calendar"></i>
                      {{globalService.Date(tournament.start_at)}}
                    </p>
                    <p class="zero_margin">
                      <i class="icon-clock"></i>
                      {{globalService.Time(tournament.start_at)}}
                    </p>
                  </div>
                  <div class="status" style="margin-top:auto;">
                    <div class="icon"
                         [ngClass]="{'active':tournament.status=='Waiting Players to Join',
                                'finished':tournament.status=='Finished', 'inprogress':tournament.status=='In Progress'}"></div>
                    <p>{{tournament.status}}</p>
                  </div>

                  <div class="rule-shape">&#10052;</div>
                </div>
              </div>


            </div>
          </a>

        </div>
      </div>


    </mat-tab>

    <mat-tab label="tab2" id="test">
      <ng-template mat-tab-label>
        <i class="icon-trophy"></i>
        Winners
      </ng-template>
      <div style="margin:10px 0;" *ngFor="let tournament of (eventService.eventTournaments|async)?.data">
        <div class="col-sm-4">
          <a class="tag-container" href="https://www.gbarena.com/tournaments/{{tournament.code}}" target="_blank">
            <div class="tag">
              <div class="tag-side tag-3-side">
                <div class="tag-text tag-3-text">
                  <div class="snow"></div>
                  <!--<div class="tag-cover" [ngStyle]="{'background-image': 'url('+tournament.cover_picture+')'}">-->
                  <!--</div>-->

                  <div class="text">
                    <h1>{{tournament.name}}</h1>
                    <h2>Winners</h2>
                    <div class="flex_block row_wrap" *ngIf="tournament.winners?.length>0 ;else noWinners">
                      <div class="winner" *ngFor="let winner of tournament.winners">
                        <img src="{{winner.participant_avatar}}"/>
                        <p class="zero_margin">{{winner.participant_name}}</p>
                      </div>
                    </div>
                    <ng-template #noWinners>
                      <div class="big_block christmas_message">
                        <p class="zero_margin">No Winners yet.</p>
                      </div>
                    </ng-template>
                  </div>

                  <div class="rule-shape">&#10052;</div>
                </div>
              </div>


            </div>
          </a>

        </div>
      </div>

    </mat-tab>

  </mat-tab-group>


  <div class="big_block points" *ngIf="(eventService.eventTournaments|async)?.data?.length==0">
    <div class="content text-center">
      <p>No Tournaments yet.</p>
    </div>
  </div>
</ng-container>
<ng-template #loading>
  <app-loading-indicator></app-loading-indicator>
</ng-template>
